import { useParams } from "react-router";
import { useUniquePossibilities } from "@hooks/useUniquePossibilities";
import Grid from "./NPVGrid";
import useHeaderChange from "@hooks/useHeaderChange";
import NetPresentValueSkeleton from "./NetPresentValueSkeleton";
import TopSettings from "./TopSettings";
import IRR from "./IRR";
import HiddenOption from "./HiddenOption";
import { useState } from "react";
import NoUPMessage from "@/components/NoUPMessage";
import withDisclaimer from "@/hoc/withDisclaimer";
import { Clients } from "@/types/types";
import { checkClientsBirthdates } from "@/helper/helper";
import { NoContactBirthDateMessage } from "../HouseholdContact";
import PrintNPVButton from "./PrintNPVButton";

function NetPresentValue() {
  const { id } = useParams();
  const {
    data: upData,
    isError: upIsError,
    isRefetching: upRefetching,
    isLoading: upLoading,
  } = useUniquePossibilities(id!);
  const [showHiddenRows, setShowHiddenRows] = useState(false);
  const [isMutating, setIsMutating] = useState(false);

  useHeaderChange(id!, "The NPV Solution");

  if (upLoading || upRefetching) return <NetPresentValueSkeleton />;
  if (upIsError) return <span>Failed to fetch unique possibilities</span>;
  if (checkClientsBirthdates(upData?.household)) {
    return <NoContactBirthDateMessage household={upData?.household} />;
  }
  if (!upData?.data?.length) return <NoUPMessage />;

  return (
    <div className="print-zoom-80 flex flex-col gap-9 print:gap-4 print:pt-4">
      <TopSettings uniquePossibilities={upData} setIsMutating={setIsMutating} />
      {!isMutating ? (
        <>
          <Grid
            household={upData.household as Required<Clients>}
            uniquePossibilities={upData}
            showHiddenRows={showHiddenRows}
          />
          <div className="flex justify-between">
            <span className="flex gap-4 align-middle">
              <IRR />
              <PrintNPVButton
                externalCode={upData?.household?.externalCode}
                showHiddenRows={showHiddenRows}
              />
            </span>
            <HiddenOption showHiddenRows={showHiddenRows} setShowHiddenRows={setShowHiddenRows} />
          </div>
        </>
      ) : (
        <NetPresentValueSkeleton />
      )}
    </div>
  );
}

const NPVWithDisclaimer = withDisclaimer(NetPresentValue);

export default NPVWithDisclaimer;
